import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGlobalContext } from '../context/GlobalContext';

const Help = () => {
  const { siteInfo, currentLang, loading, error } = useGlobalContext();
  const { t } = useTranslation();

  if (loading) {
    return (
      <div className="text-center">
        <p>{t('Chargement...')}</p>
      </div>
    );
  }

  if (error || !siteInfo) {
    return (
      <div className="text-center">
        <p>{t('Une erreur est survenue')}</p>
      </div>
    );
  }

  const helpData = siteInfo.help?.[currentLang];
  const contactData = siteInfo.contact?.[currentLang];

  if (!helpData) {
    return (
      <div className="text-center">
        <p>{t('Données d\'aide non disponibles pour cette langue.')}</p>
      </div>
    );
  }

  const getContactText = (contactData) => {
    if (!contactData) return '';
    
    if (contactData.type === 'email') {
      return t('Retrouvez plus d\'aide sur nos services et des moyens de nous contacter dans le <a href="mailto:{{siteInfo.contact[currentLang].data}}">Centre Support Client Ikea</a>.')
        .replace('{{siteInfo.contact[currentLang].data}}', contactData.data);
    } else {
      return t('Retrouvez plus d\'aide sur nos services et des moyens de nous contacter dans le <a href="{{siteInfo.contact[currentLang].data}}">Centre Support Client Ikea</a>.')
        .replace('{{siteInfo.contact[currentLang].data}}', contactData.data);
    }
  };

  return (
    <div id="help">
      <h1 
        className="text-center" 
        dangerouslySetInnerHTML={{ __html: helpData.title }}
      />

      <div 
        className="main" 
        dangerouslySetInnerHTML={{ __html: helpData.text }}
      />

      <div className="help-footer text-center">
        <h2>{t("Besoin d'aide supplémentaire ?")}</h2>
        
        {contactData && (
          <>
            <p dangerouslySetInnerHTML={{ __html: getContactText(contactData) }} />

            <div>
              {contactData.type === 'email' ? (
                <a 
                  className="btn" 
                  href={`mailto:${contactData.data}`}
                >
                  {t('Accéder au Centre Support Client')}
                </a>
              ) : (
                <a 
                  className="btn" 
                  href={contactData.data}
                >
                  {t('Accéder au Centre Support Client')}
                </a>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Help;